<template>
    <div>
        <page-header :buttons="buttons" :additional="[]" @method="methodHandler">
            <template slot="title">Settings</template>
        </page-header>
        <Spinner v-if="loading" />
        <div v-if="!loading" class="lg:px-6 px-4 pt-4">
            <input-toggle
                v-model="allowMultipleDeviceLogins"
                label="Allow Multiple Device Log Ins"
                name="allow_multiple_device_logins"
            />
            <p class="mt-2 text-sm text-gray-600 max-w-xl">
                When this is off, signing in ends sessions on every other device.
            </p>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "Settings",
        data: function() {
            return {
                loading: true,
                allowMultipleDeviceLogins: false,
                buttons: [{
                    label: 'Save',
                    icon: 'save',
                    iconClass: 'text-green-600',
                    type: 'method',
                    method: 'save',
                }]
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
            save: function () {
                this.loading = true

                axios.put(process.env.VUE_APP_API_URL + '/settings', {
                    allow_multiple_device_logins: this.allowMultipleDeviceLogins
                })
                    .then(() => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Success',
                            text: 'Settings updated',
                            duration: 5000
                        });
                    })
                    .catch(error => {
                        console.error(error)
                        this.$notify({
                            group: 'main',
                            position: 'bottom right',
                            type: 'error',
                            title: 'Error',
                            text: 'Error updating settings',
                            duration: 5000
                        });
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        mounted() {
            axios.get(process.env.VUE_APP_API_URL + '/settings')
                .then(response => {
                    this.allowMultipleDeviceLogins = response.data.allow_multiple_device_logins
                })
                .catch(error => {
                    console.error(error)
                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Error',
                        text: 'Error loading settings',
                        duration: 5000
                    });
                })
                .finally(() => {
                    this.loading = false
                })
        },
    }
</script>
